export default __webpack_public_path__ + "static/media/Capacidade-WiFi-2.e25777d4.jpg";